import { useEffect, useState } from 'react';

import { logger } from '../services/loggerService';

const useMicroFrontendUrlFromManifest = ({
  partialIndexUrl,
  enableManifestFile,
  legacyIndexUrl,
  microFrontendWindowName,
}) => {
  const [indexUrl, setIndexUrl] = useState<string>('');
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchManifest = async () => {
      try {
        const manifestResponse = await fetch(`${partialIndexUrl}/.vite/manifest.json`);
        const manifest = await manifestResponse.json();
        setIndexUrl(`${partialIndexUrl}/${manifest['index.html'].file}`);
      } catch (error) {
        logger.error(`Error fetching ${microFrontendWindowName} manifest:`, error);
        setError(error as Error);
      }
    };

    if (enableManifestFile) {
      partialIndexUrl
        ? fetchManifest()
        : setError(new Error('Partial index URL is required when enableManifestFile is true'));
    } else {
      !legacyIndexUrl &&
        !partialIndexUrl &&
        setError(
          new Error(
            'Legacy index URL or partial index URL is required when enableManifestFile is false'
          )
        );
      legacyIndexUrl
        ? setIndexUrl(legacyIndexUrl)
        : setIndexUrl(`${partialIndexUrl}/assets/index.js`);
    }
  }, []);

  return { indexUrl, error };
};

export default useMicroFrontendUrlFromManifest;
